export interface ProgressProps {
  /** 0 bis 1. Weggelassen bedeutet unbestimmt (laufende Animation). */
  value?: number | undefined;
  label: string;
  /** Zusatztext rechts, etwa "1,2 GB von 4,0 GB". */
  detail?: string | undefined;
}

/**
 * Fortschrittsbalken.
 *
 * Bewusst nicht als natives <progress>: dessen Darstellung laesst sich zwischen
 * den Engines nicht zuverlaessig auf die Pillenform bringen. Die ARIA-Rolle
 * liefert dieselbe Semantik.
 *
 * Der Prozentwert steht immer auch als Text da -- ein Balken allein ist fuer
 * Screenreader-Nutzer und bei Farbfehlsichtigkeit zu wenig.
 */
export function Progress({ value, label, detail }: ProgressProps): React.ReactElement {
  const indeterminate = value === undefined;
  const percent = indeterminate ? 0 : Math.round(Math.min(1, Math.max(0, value)) * 100);

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "var(--space-2)",
          marginBottom: "var(--space-1)",
          fontSize: "var(--text-small)",
          color: "var(--color-granite)",
        }}
      >
        <span>{label}</span>
        <span style={{ fontVariantNumeric: "tabular-nums" }}>
          {detail ?? (indeterminate ? "läuft…" : `${percent} %`)}
        </span>
      </div>
      <div
        className={["progress", indeterminate ? "progress--indeterminate" : null]
          .filter(Boolean)
          .join(" ")}
        role="progressbar"
        aria-label={label}
        {...(indeterminate
          ? {}
          : { "aria-valuenow": percent, "aria-valuemin": 0, "aria-valuemax": 100 })}
      >
        <span className="progress__bar" style={indeterminate ? undefined : { width: `${percent}%` }} />
      </div>
    </div>
  );
}
